import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class ItemTabVM extends InterActive{
    private id:string 
    private value:string 
    private dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'
    private deleting:boolean = false

    public get Id():string { return this.id }
    public get Value():string { return this.value }
    public get DataType():'التخصص'|'المستوى'|'الكورس'|'الجهة' { return this.dataType}
    public get Deleting():boolean { return this.deleting }

    public set Id(value:string){ this.id = value; this.update() }
    public set Value(value:string){ this.value = value; this.update() }
    public set DataType(value:'التخصص'|'المستوى'|'الكورس'|'الجهة'){ this.dataType = value; this.update() }
    public set Deleting(value:boolean){ this.deleting = value; this.update() }

    constructor(id:string , value:string , dataType:'التخصص'|'المستوى'|'الكورس'|'الجهة'){
        super()
        this.id = id
        this.value = value
        this.dataType = dataType
    }


    public delete(onDelete?:(id:string)=>void){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.deleteItem(this.id, this.dataType)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(onDelete)onDelete(this.id)
                            }else {
                                this.Deleting= false
                                Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                            }
                        }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{ Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }        
            }
        )
    }
}